import { cx } from '../../lib/utils'

interface AlertProps {
  children: React.ReactNode
  variant?: 'error' | 'warning' | 'info' | 'success'
  className?: string
}

// Riquadri con barra a sinistra (brand kit): ambra per l'avviso, navy per l'informazione.
const VARIANTS = {
  error: 'border-red-500 bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-400',
  warning: 'border-amber-500 bg-amber-100 text-primary-600 dark:bg-amber-500/10 dark:text-amber-300',
  info: 'border-primary-600 bg-gray-100 text-primary-600 dark:border-gray-300 dark:bg-gray-800 dark:text-gray-50',
  success: 'border-emerald-500 bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400',
} as const

export default function Alert({ children, variant = 'error', className }: AlertProps) {
  return (
    <p
      role="alert"
      className={cx('rounded-r border-l-4 px-4 py-3 text-sm', VARIANTS[variant], className)}
    >
      {children}
    </p>
  )
}
